export const environment = {
  unimagenBaseUrl: 'https://api.unimagen.ovh/rum',
  keycloakUrl: 'https://auth.unimagen.ovh/',
  realm: 'unimagen',
  clientId: 'unimagen'
};
